import { BarChart, Heatmap, Loading, EmptyState } from '@dsi/react-eds';
import isEmpty from 'lodash/isEmpty';
import React, { useEffect, useState } from 'react';
import GISMap from '../GISMap';
import HorizontalBarChart from '../D3Charts/HorizontalBarChart';
import VerticalBarChart from '../D3Charts/VerticalBarChart';
import D3HeatMap from '../D3Charts/D3HeatMap';
import D3LineChart from '../D3Charts/D3LineChart';
import D3PieChart from '../D3Charts/D3PieChart';
import D3DonutChart from './D3DonutChart';
import useMapData from '../../Context/MapDataContext';

import useCustomerData from '../../Context/CustomerDataContext';
import { useGlobalFilterData } from '../../hooks/useGlobalFilterData';
import useScriptExecution from '../../hooks/useScriptExecution';
// import { setDashboardUnfilteredData } from './reducer.js'
import { connect } from 'react-redux';
import {
  getRegionsString,
  getCirclesString,
  getCitiesString,
  getSitesString
} from '../../utils/functionUtils';

const useChartData = (
  apiURL,
  method,
  startDate,
  endDate,
  selectedRegions,
  selectedCircles,
  selectedCities,
  selectedSites,
) => {
  const {
    mutate,
    isLoading,
    isError,
    error,
    data: dataForCharts
  } = useScriptExecution(apiURL, method || 'POST');

  useEffect(() => {
    let isMounted = true;
    let body = {};

    if (selectedRegions && selectedRegions.length > 0) {
      body.regions = getRegionsString(selectedRegions);
    }

    if (selectedCircles && selectedCircles.length > 0) {
      body.circles = getCirclesString(selectedCircles);
    }

    if (selectedCities && selectedCities.length > 0) {
      body.cities = getCitiesString(selectedCities);
    }

    if (selectedSites && selectedSites.length > 0) {
      body.sites = getSitesString(selectedSites);
    }

    body.toTime = endDate;
    body.fromTime = startDate;
    body.page = 1;

    mutate(body);

    return () => {
      isMounted = false;
    };
  }, [
    apiURL,
    method,
    startDate,
    endDate,
    selectedRegions,
    selectedCircles,
    selectedCities,
    selectedSites,
    mutate
  ]);

  return { isLoading, isError, error, dataForCharts };
};

const DynamicChart = (props) => {
  const { apiURL, method, type, xAxis, yAxis, dashboardUnfilteredData, setDashboardUnfilteredData, Mzoom } = props;
  const { customer } = useCustomerData();
  const { zoom, mapCenter } = useMapData();

  const {
    startDate,
    endDate,
    selectedRegions,
    selectedCircles,
    selectedCities,
    selectedSites
  } = useGlobalFilterData();

  const { isLoading, isError, error, dataForCharts } = useChartData(
    apiURL,
    method,
    startDate,
    endDate,
    selectedRegions,
    selectedCircles,
    selectedCities,
    selectedSites
  );

  let chartData
  let unFilteredFlag=false
  const chartID = apiURL?.split('/').pop();
  // if ((
  //   (chartData && chartData[0]?.values?.length !== 0) ||
  //   (chartData && chartData?.series && chartData?.series[0]?.values.length !== 0)
  // ) || (props.source !== "dashboard")) {
    chartData = dataForCharts
  // } else {
  //   chartData = dashboardUnfilteredData[chartID]
  //   if (selectedRegions.length >0) {
  //     unFilteredFlag = true
  //   }
  // }
  

  // useEffect(() => {
  //   if ((
  //     (dataForCharts && dataForCharts[0]?.values?.length !== 0) ||
  //     (dataForCharts && dataForCharts?.series && dataForCharts?.series[0]?.values.length !== 0)
  //   ) && (props.source === "dashboard") && (selectedRegions.length === 0)) {
  //     let tempDashData = Object.keys(dashboardUnfilteredData).length > 0 ? dashboardUnfilteredData : []
  //     tempDashData[chartID] = dataForCharts
  //     setDashboardUnfilteredData(tempDashData)
  //   }
  // }, [dataForCharts])

  // useEffect(() => {
  //   if (props.source === "dashboard" && (!chartData ||
  //     (chartData && chartData[0]?.values?.length === 0) ||
  //     (chartData && chartData?.series && chartData?.series[0]?.values.length === 0) && Object.keys(dashboardUnfilteredData)?.length != 0 && dashboardUnfilteredData[chartID])) {
    
  //       if (chartData) {
  //         chartData.length=0
  //       }else{
  //         chartData=[]
  //       }
        
  //     chartData = dashboardUnfilteredData[chartID]
  //     console.log('dashboardUnfilteredData[chartID]', chartID);
  //     console.log('dashboardUnfilteredData[chartID]', dashboardUnfilteredData[chartID]);
  //     console.log('dashboardUnfilteredData[chartID]', chartData);
  //   }
  // }, [dashboardUnfilteredData])

  // console.log('dashboardUnfilteredData[chartID]', chartID);
  // console.log('dashboardUnfilteredData[chartID]', chartData);
 if (isLoading) {
    return (
      <div className="alignCenter">
        <Loading size="medium" className="alignCenter" />
      </div>
    );
  }
  
  if (type?.toLowerCase() === 'x-infra-map') {
    return <GISMap data={chartData} isError={isError} error={error} fullZoom={Mzoom ? Mzoom : props.maxMinChartToggle ? 7 : zoom} />;
  }

 

  if (isError) {
    return (
      <div className="alignCenter">
        <p>
          {error?.message ? error?.message : 'Something went wrong. Please try again.'}
        </p>
      </div>
    );
  }

  if (
    !chartData ||
    (chartData && chartData[0]?.values.length === 0) ||
    (chartData && chartData?.series && chartData?.series[0]?.values.length === 0)
  ) {
    return (
      <EmptyState>
        <p>No data available.</p>
      </EmptyState>
    );
  }

  switch (type?.toLowerCase()) {
    case 'heatmap':
      return <><D3HeatMap data={chartData} id="heatmapone" /><div>{unFilteredFlag?"No data available for the applied filters. Displaying global unfiltered data":<></>}</div></>;
    case 'bar':
      return <><HorizontalBarChart {...props} id={chartID} data={chartData} /><div>{unFilteredFlag?"No data available for the applied filters. Displaying global unfiltered data":<></>}</div></>;
    case 'horizontal_bar':
      return <><VerticalBarChart {...props} id={chartID} data={chartData} /><div>{unFilteredFlag?"No data available for the applied filters. Displaying global unfiltered data":<></>}</div></>;
    case 'line':
      return <><D3LineChart {...props} id={chartID} data={chartData} /><div>{unFilteredFlag?"No data available for the applied filters. Displaying global unfiltered data":<></>}</div></>;
    case 'pie':
      return <><D3PieChart {...props} id={chartID} data={chartData} /><div>{unFilteredFlag?"No data available for the applied filters. Displaying global unfiltered data":<></>}</div></>;
    case 'donut':
      return <><D3DonutChart {...props} id={chartID} data={chartData} /><div>{unFilteredFlag?"No data available for the applied filters. Displaying global unfiltered data":<></>}</div></>;
    default:
      return null;
  }
};

const mapStateToProps = (state) => {
//console.log('dshState',state);

  return {
    // dashboardUnfilteredData: state.dashUnfilDReducer.dashboardUnfilteredData,
    maxMinChartToggle: state.dashUnfilDReducer.maxMinChartToggle
  };
}

const mapDispatchToProps = {
  // setDashboardUnfilteredData
}

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(DynamicChart));
// export default React.memo(DynamicChart);
